import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function WhereMovementMatters() {
  return <section className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/hero_male_physiotherapist_bright_modern_clinic.png)]">
      {}
      <div className="absolute inset-0 bg-primary/60 backdrop-blur-sm" />
      
      {}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl font-display font-bold text-white leading-[1.2] tracking-wide mb-6 animate-fade-in-up">
          Align Physiotherapy – Where Movement Matters
        </h1>
        
        <p className="text-lg md:text-xl text-white/90 font-sans leading-[1.6] mb-8 max-w-2xl mx-auto animate-fade-in-up-delay-100">
          Expert, evidence-based physiotherapy care in Warmsworth, Doncaster. 
          Helping you move better, feel better, and get back to doing what you love.
        </p>
        
        <div className="animate-fade-in-up-delay-200">
          <Button asChild size="lg" className="bg-accent text-white hover:bg-accent/90 shadow-medium px-8 py-4 text-base font-semibold rounded-lg transition-all duration-[150ms] hover:-translate-y-0.5 hover:shadow-strong">
            <Link to="/ContactPage">
              Book Your Appointment
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}